<template>
    <div>
        <div class="d-flex justify-center align-center">
            <h4 style="color: dimgrey">{{ $t('auth.preRegistration.title') }}</h4>
        </div>

        <v-form class="mt-2" ref="form" lazy-validation>
            <div class="inner-registration-form">
                <div class="d-flex justify-center align-center">
                    <v-text-field v-model="form.name" :rules="[rules.required, rules.maxCharsText]" autocomplete="name" autofocus required dense class="text-field-asterisk mb-2 left-input myprovet-auth-input" data-cy="name">
                        <template v-slot:label>
                            <span>{{ $t('userDetails.name') }}</span>
                            <v-icon class="red--text" style="font-size: 0.75rem !important"> mdi-asterisk </v-icon>
                        </template>
                    </v-text-field>
                </div>

                <div class="d-flex justify-center align-center">
                    <v-text-field v-model="form.company" :label="$t('register.company')" :rules="[rules.maxCharsText]" required dense class="mb-2 left-input myprovet-auth-input" data-cy="company"></v-text-field>
                </div>

                <!-- Normal line 3 -->
                <div class="layout-normal left-input justify-center">
                    <v-text-field v-model="form.taxpayer_number" :rules="[rules.required, rules.minCharsPhoneNIF, rules.maxCharsText]" required dense class="text-field-asterisk pl-2 mr-2 col-md-6 left-input myprovet-auth-input" data-cy="taxpayer_number">
                        <template v-slot:label>
                            <span>{{ $t('register.vat') }}</span>
                            <v-icon class="red--text" style="font-size: 0.75rem !important"> mdi-asterisk </v-icon>
                        </template>
                    </v-text-field>

                    <v-text-field v-model.number="form.client_number" :rules="[rules.maxCharsClientNumber]" type="number" :label="$t('register.clientNumber')" required dense class="pl-2 ml-2 col-md-6 left-input myprovet-auth-input auth-number" data-cy="client_number"></v-text-field>
                </div>

                <!-- Dense line 3 -->
                <div class="layout-dense left-input justify-center">
                    <v-text-field v-model="form.taxpayer_number" :rules="[rules.required, rules.denseMinCharsPhoneNIF, rules.denseMaxCharsText]" required dense class="text-field-asterisk pl-0 pr-1 col-md-4 left-input myprovet-auth-input" data-cy="taxpayer_number-dense">
                        <template v-slot:label>
                            <span>{{ $t('register.vat') }}</span>
                            <v-icon class="red--text" style="font-size: 0.75rem !important"> mdi-asterisk </v-icon>
                        </template>
                    </v-text-field>

                    <v-text-field v-model.number="form.client_number" :rules="[rules.denseMaxCharsClientNumber]" type="number" :label="$t('register.clientNumber')" required dense class="text-field-asterisk px-1 col-md-4 left-input myprovet-auth-input auth-number" data-cy="client_number-dense"></v-text-field>

                    <v-text-field v-model="form.telephone" :rules="[rules.required, rules.denseMinCharsPhoneNIF, rules.denseMaxCharsText]" autocomplete="telephone" required dense class="pl-1 pr-0 col-md-4 myprovet-auth-input left-input" data-cy="telephone-dense">
                        <template v-slot:label>
                            <span>{{ $t('register.phone') }}</span>
                            <v-icon class="red--text" style="font-size: 0.75rem !important"> mdi-asterisk </v-icon>
                        </template>
                    </v-text-field>
                </div>

                <!-- Normal line 4 -->
                <div class="justify-center layout-normal">
                    <v-text-field v-model="form.email" :rules="[rules.required, rules.email, rules.denseMaxCharsText]" type="email" autocomplete="email" required dense class="text-field-asterisk pl-2 mr-2 col-md-6 myprovet-auth-input left-input" data-cy="email">
                        <template v-slot:label>
                            <span>{{ $t('register.email') }}</span>
                            <v-icon class="red--text" style="font-size: 0.75rem !important"> mdi-asterisk </v-icon>
                        </template>
                    </v-text-field>

                    <v-text-field v-model="form.telephone" :rules="[rules.required, rules.minCharsPhoneNIF, rules.maxCharsText]" autocomplete="telephone" required dense class="text-field-asterisk pl-2 ml-2 col-md-6 myprovet-auth-input left-input" data-cy="telephone">
                        <template v-slot:label>
                            <span>{{ $t('register.phone') }}</span>
                            <v-icon class="red--text" style="font-size: 0.75rem !important"> mdi-asterisk </v-icon>
                        </template>
                    </v-text-field>
                </div>

                <!-- Normal line 5 -->
                <div class="justify-center layout-normal">
                    <v-text-field v-model="form.financial_email" :rules="[rules.email, rules.denseMaxCharsText]" type="email" :label="$t('register.financialEmail')" autocomplete="email" dense class="pl-2 mr-2 col-md-6 left-input myprovet-auth-input" data-cy="financial_email"></v-text-field>

                    <v-text-field v-model="form.commercial_email" :rules="[rules.email, rules.denseMaxCharsText]" type="email" :label="$t('register.commercialEmail')" dense class="pl-2 ml-2 col-md-6 left-input myprovet-auth-input" data-cy="commercial_email"></v-text-field>
                </div>

                <!-- Dense line 4 -->
                <div class="justify-center layout-dense">
                    <v-text-field v-model="form.email" :rules="[rules.required, rules.email, rules.denseMaxCharsText]" type="email" autocomplete="email" required dense class="text-field-asterisk pl-0 pr-1 col-md-4 myprovet-auth-input left-input" data-cy="email-dense">
                        <template v-slot:label>
                            <span>{{ $t('register.email') }}</span>
                            <v-icon class="red--text" style="font-size: 0.75rem !important"> mdi-asterisk </v-icon>
                        </template>
                    </v-text-field>

                    <v-text-field v-model="form.financial_email" :rules="[rules.email, rules.denseMaxCharsText]" type="email" :label="$t('register.financialEmail')" autocomplete="email" dense class="px-1 col-md-4 left-input myprovet-auth-input" data-cy="financial_email-dense"></v-text-field>

                    <v-text-field v-model="form.commercial_email" :rules="[rules.email, rules.denseMaxCharsText]" type="email" :label="$t('register.commercialEmail')" dense class="pl-1 pr-0 col-md-4 left-input myprovet-auth-input" data-cy="commercial_email-dense"></v-text-field>
                </div>

                <template v-if="form.errors">
                    <div class="errors-text">
                        <p v-for="error in form.errors" :key="error" class="red--text mb-0" data-cy="errors">
                            {{ tServer(String(error)) }}
                        </p>
                    </div>
                </template>
            </div>

            <div class="privacy-checkbox-container d-flex align-center" style="margin-left: 11px">
                <v-checkbox v-model="form.conditions" class="mt-0" hide-details data-cy="ck-conditions"> </v-checkbox>

                <span class="font-size-xs grey--text privacy-terms-text">
                    {{ $t('register.consent') }}
                    <u style="cursor: pointer" @click="openPrivacyPolicyDialog()">{{ $t('register.terms') }}</u>.
                </span>
            </div>

            <div class="auth-register-normal justify-center mt-4 px-16">
                <v-btn @click="submitForm" :loading="loading" class="mt-1 myprovet-btn-ok" data-cy="register-button"> {{ $t('register.submit') }} </v-btn>
            </div>
        </v-form>

        <!-- Auth link -->
        <div class="responsive-auth-login-link auth-login-normal mb-0">
            <span class="d-flex justify-center responsive-auth-font" style="color: darkgrey">
                {{ $t('register.haveAccount') }}

                <inertia-link class="no-underline" href="/"> &nbsp;{{ $t('register.signIn') }}</inertia-link>
            </span>
        </div>

        <!-- Dense auth link -->
        <div class="responsive-auth-login-link auth-link-dense align-center justify-space-around mb-0">
            <span class="d-flex justify-center responsive-auth-font" style="color: darkgrey">
                {{ $t('register.haveAccount') }}

                <inertia-link class="no-underline" href="/"> &nbsp;{{ $t('register.signIn') }}</inertia-link>
            </span>

            <v-btn @click="submitForm" :loading="loading" style="margin-top: -5px" class="myprovet-btn-ok" data-cy="register-button-dense"> {{ $t('register.submit') }} </v-btn>
        </div>
        <!-- End of auth links -->

        <privacy-policy-dialog v-if="isPrivacyPolicyDialogOpen" :value="isPrivacyPolicyDialogOpen" @onCancel="isPrivacyPolicyDialogOpen = false" width="40vw" max-height="80vh"> </privacy-policy-dialog>
    </div>
</template>

<script>
import AuthLayout from '../Layouts/AuthLayout';
import { i18n } from '@/i18n';

export default {
    data() {
        return {
            form: {
                name: null,
                company: null,
                taxpayer_number: null,
                client_number: null,
                email: null,
                telephone: null,
                financial_email: null,
                commercial_email: null,
                conditions: null,
            },
            rules: {
                required: (value) => (value && !!value) || i18n.t('validation.required'),
                minCharsPhoneNIF: (value) => !value || (value && value.length > 8) || i18n.t('register.rules.min9'),
                denseMinCharsPhoneNIF: (value) => !value || (value && value.length > 8) || i18n.t('register.rules.min9Short'),

                maxCharsText: (value) => !value || (value && value.length < 251) || i18n.t('register.rules.max250'),
                denseMaxCharsText: (value) => !value || (value && value.length < 251) || i18n.t('register.rules.max250Short'),

                maxCharsClientNumber: (value) => !value || (value && value.toString().length < 13) || i18n.t('register.rules.max12'),
                denseMaxCharsClientNumber: (value) => !value || (value && value.toString().length < 13) || i18n.t('register.rules.max12Short'),

                email: function (value) {
                    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return !value || re.test(value) ? true : i18n.t('createUser.invalidEmail');
                },
            },
            loading: false,
            isPrivacyPolicyDialogOpen: false,
        };
    },

    methods: {
        openPrivacyPolicyDialog() {
            this.isPrivacyPolicyDialogOpen = true;
        },

        submitForm() {
            if (!this.$refs.form.validate()) return;

            this.loading = true;

            this.$inertia.post('/register', this.form, {
                onSuccess: () => {
                    this.loading = false;
                    this.form.errors = null;
                },
                onError: (errors) => {
                    this.loading = false;
                    this.form.errors = errors;
                },
            });
        },
    },

    layout: AuthLayout,
};
</script>

<style scoped>
.no-underline {
    text-decoration: none;
}

.privacy-terms-text {
    line-height: 16px !important;
    text-align: justify;
    font-weight: bold;
}

.inner-registration-form {
    width: 432px;
    margin-left: 14px;
    margin-right: 14px;
}

.privacy-checkbox-container {
    height: auto;
    flex-grow: 1;
    width: 432px;
}

.errors-text {
    font-size: 0.75rem !important;
    font-weight: 500;
    line-height: 1.375rem;
}

.layout-normal {
    display: none !important;
}

.layout-dense {
    display: flex !important;
}

.auth-link-dense {
    display: flex !important;
}

.auth-register-normal {
    display: none !important;
}

.auth-login-normal {
    display: none !important;
}

@media only screen and (min-height: 780px) {
    .layout-normal {
        display: flex !important;
    }

    .layout-dense {
        display: none !important;
    }

    .auth-link-dense {
        display: none !important;
    }

    .auth-register-normal {
        display: flex !important;
    }

    .auth-login-normal {
        display: block !important;
    }
}
</style>
